import axiosInstance from "../../../core/api/axios";
import { IEssayTheme } from "../../../core/models/essay";
import { useThemeFilterStore } from "../stores/themeFilterStore";
import { useThemeListStore } from "../stores/themeListStore";

export async function getTheme(slug: string): Promise<IEssayTheme> {
  try {
    const response = await axiosInstance.get(`/essaythemes/${slug}`)

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function getThemes(): Promise<[]> {
  try {
    const video = useThemeFilterStore.getState().video;
    const banca = useThemeFilterStore.getState().banca;
    const axis = useThemeFilterStore.getState().axis;
    const setThemes = useThemeListStore.getState().setThemes;
    const setOriginalTheme = useThemeListStore.getState().setOriginalThemes;

    let videoParsed = "", bancaParsed = "", axisParsed = "";

    if(banca.length > 0) {
      bancaParsed = JSON.stringify(banca);
    }

    if(axis.length > 0) {
      axisParsed = JSON.stringify(axis);
    }

    if(video.length === 1) {
      if(video.includes('webdoc')) {
        videoParsed = 'webdoc'
      } else {
        videoParsed = 'video'
      }
    } else if(video.length > 1) {
      videoParsed = 'all'
    }

    const { data } = await axiosInstance.get(`/essayactivity?correction=todos&correctionType=${bancaParsed}&supportMaterial=${videoParsed}&themeAxis=${axisParsed}`)

    setOriginalTheme(data.allthemes);
    setThemes(data.allthemes);
    
    return data;
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function getLesson(slug: string) {
  try {
    const response = await axiosInstance.get(`/lessons/${slug}`)

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}
